import { Container } from 'react-bootstrap';

import { CannabisLicensesContextProvider } from './CannabisLicensesContext';
import { StylePage } from '../../components/styles/Page.styled';
import PageHeader from '../../components/common/pageHeader/PageHeader';
import CreateLicense from '../../components/cannabisLicenses/CreateLicense';
import AddLicenseAlerts from '../../components/cannabisLicenses/alerts/AddLicenseAlerts';
import CannabisLicenseHelper from '../../helpers/features/CannabisLicensesHelper';

function LicenseCreate(props) {
  return (
    <StylePage>
      <Container>
        <CannabisLicensesContextProvider componentProps={props}>
          <PageHeader
            title={CannabisLicenseHelper.LICENSES_HEADER}
            subheader={CannabisLicenseHelper.LICENSES_SUBHEADER}
          />
          <CreateLicense />
          <AddLicenseAlerts />
        </CannabisLicensesContextProvider>
      </Container>
    </StylePage>
  );
}

export default LicenseCreate;
